<!-- Тот же самый BannerUniversalSketchTags только с динамическими тегами дат, тк пока с бека приходит только статичный json -->
<template>
  <div
    ref="bannerRef"
    class="listing-banner-dates-sketch"
  >
    <div class="info">
      <div
        class="info__title"
        v-html="props.banner?.title"
      />
      <banner-tags
        :tags="tags"
        @on-click="emit('onClick')"
      />
    </div>
    <div class="image">
      <ui-image
        :src="props.banner.image"
        :alt="t('bannerInjection.bannerImage')"
        loading="lazy"
        decoding="async"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { GetListingBannersItemBannerParamsResponse } from '@/shared/api/experience';
  import BannerTags from '@/entities/bannerInjection/ui/BannerTags.vue';
  import { useI18n } from '@experience/i18n';
  import { UiImage } from '@experience/core-image-ui';
  import ru from '../i18n/ru.json';
  import { useDateTags } from '@/entities/bannerInjection/composables/useDateTags.ts';
  import type { ContextGeoSubject } from '@/shared/types/geography.ts';

  interface Props {
    banner: GetListingBannersItemBannerParamsResponse;
    defaultSoguFields: ContextGeoSubject;
  }

  const props = defineProps<Props>();

  const emit = defineEmits<{ onClick: [] }>();

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const { tags } = useDateTags();
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as typography;

  .listing-banner-dates-sketch {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0;
  }

  .info {
    margin-bottom: 24px;
  }

  .info__title {
    margin-bottom: 24px;

    @include typography.base-700-500-extra;
  }

  .info__description {
    margin-bottom: 16px;

    @include typography.base-400-400-regular;
  }

  .image {
    display: flex;
    flex-grow: 1;
    justify-content: center;

    img {
      max-width: 100%;
    }
  }
</style>
